import {publishOpenCopilotChat, publishPreloadCopilotChat} from '@github-ui/copilot-chat/utils/copilot-chat-events'
import {CopilotChatIntents, type FileDiffReference} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {sendEvent} from '@github-ui/hydro-analytics'
import {CopilotIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {useCallback} from 'react'

export interface CopilotDiffExplainButtonProps {
  fileDiffReference: FileDiffReference
}

export function CopilotDiffExplainButton({fileDiffReference}: CopilotDiffExplainButtonProps) {
  const handleClick = useCallback(() => {
    sendEvent('copilot.file-diff.attach', {target: 'file-diff-header', mode: 'assistive'})
    publishOpenCopilotChat({
      intent: CopilotChatIntents.conversation,
      references: [fileDiffReference],
      attachThread: true,
      id: 'file-diff-header',
    })
  }, [fileDiffReference])

  const handlePreload = () => {
    publishPreloadCopilotChat()
  }

  return (
    <IconButton
      icon={CopilotIcon}
      size="small"
      aria-label="Ask about this diff"
      onClick={handleClick}
      onMouseEnter={handlePreload}
      onFocus={handlePreload}
      data-testid="copilot-diff-explain-button"
    />
  )
}
